/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { Row,Col, Image } from "react-bootstrap";
import { KTCookie } from "../../../../_assets/js/components/cookie";
import { shallowEqual, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const intl = useIntl();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  const userProfile = useSelector(
    (state) => state.profileSlice.userProfile,
    shallowEqual
  );
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  // console.log(user)
  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {
          user && user.userProfile.isBlue && 
        <li
          className={`menu-item blue-program-btn mb-5 ${getMenuItemActive("/my-korek/blue-program", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/my-korek/blue-program">
            <Row>
            <Col className="pl-5" xl={12} lg={12} md={12} sm={12} xs={12}>
            <span className="menu-text">Loyalty Program</span>
            <span className="menu-desc">{user.userProfile.loyaltyPoints}</span>
            </Col></Row>
          </NavLink>
        </li>
        }
        {/*begin::1 Level*/}
        
        <li
          className={`menu-item ${getMenuItemActive("/my-korek/my-account", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/my-korek/my-account">
           
            <span className="menu-text">{intl.formatMessage({ id: "Aside.MyAccount" })}</span>
          </NavLink>
        </li>
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
